var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.0018 80.0126C48.5647 80.007 45.146 79.5098 41.8496 78.536",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0017 80.0098C67.55 80.0391 81.3687 70.1053 86.2944 55.3578C91.2201 40.6104 86.145 24.366 73.6999 15.0455C61.2548 5.72505 44.2388 5.42472 31.4725 14.3002C18.7063 23.1757 13.0611 39.2309 17.4633 54.143",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5713 45.5652H50V23.9922",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0075 88.015C16.0634 88.015 8 79.9516 8 70.0075C8 60.0634 16.0634 52 26.0075 52C35.9556 52 44.015 60.0634 44.015 70.0075C44.015 79.9516 35.9556 88.015 26.0075 88.015",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0126 69.3333V62.7266",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0086 76.6258C25.8286 76.6258 25.6805 76.7739 25.6845 76.954C25.6845 77.134 25.8326 77.2821 26.0126 77.2821C26.1927 77.2821 26.3368 77.134 26.3368 76.954C26.3368 76.7739 26.1927 76.6258 26.0086 76.6258",
    stroke: "#000",
    strokeWidth: 3.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTime);
export default __webpack_public_path__ + "static/media/clock-time.60aa8f8b0ef146492ca965475c2ea42f.svg";
export { ForwardRef as ReactComponent };